import React, { useState } from "react";
import Header from "../Header/Header";
import Aside from "../Aside/Aside";
import { AppContext } from "../../context/AppContext";
import { useMediaQuery } from "@material-ui/core";
import { useLocation } from 'react-router-dom';
import AccessGate from '../../access/AccessGate';

function Layout(props) {
  const { navigationExpanded, changeNavigationVisible } = React.useContext(AppContext);
	const [rtl] = useState(false);
	const location = useLocation();
	const isMobile = useMediaQuery('(max-width:768px)')

	React.useEffect(() => {
		changeNavigationVisible(isMobile)
	}, [isMobile, changeNavigationVisible])

	React.useEffect(() => {
		if (isMobile) {
			changeNavigationVisible(true)
		}
	}, [location.pathname, isMobile, changeNavigationVisible])

	const showBackdrop = isMobile && !navigationExpanded;

	React.useEffect(() => {
		if (showBackdrop) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
		}
		return () => {
			document.body.style.overflow = '';
		};
	}, [showBackdrop]);

	const styles = {
		overflow: "auto",
	};

	return (
		<div className={`app ${rtl ? "rtl" : ""}`}>
			<Aside rtl={rtl} />
			{showBackdrop && (
				<div 
					className="sidebar-backdrop" 
					onClick={() => changeNavigationVisible(true)}
				/>
			)}
			<main style={styles}>
				<Header />
				<div className="app-content"><AccessGate>{props.children}</AccessGate></div>
			</main>
		</div>
	);
}

export default Layout;
